import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    DispatchLoadPromotions,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, PopulateApiParameter, props => {
    if ("apiParameter" in props.parameter) {
        props.apiParameter = props.parameter.apiParameter;
        return;
    }

    props.apiParameter = {
        cartId: props.parameter.cartId,
        expand: ["validation"],
    };

    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "shipping",
            "tax",
            "carriers",
            "paymentOptions",
            "creditCardBillingAddress",
            `${Date.now()}`,
        ] as GetCartApiParameter["expand"];
    }
});
replaceInChain(chain, DispatchLoadPromotions, props => {
    if (!("cartId" in props.parameter)) {
        return;
    }

    const promotionsState = getPromotionsDataView(props.getState(), props.parameter.cartId);
    const promotionsNotLoaded = !promotionsState.value && !promotionsState.isLoading;
    if (
        props.parameter.getPromotions ||
        props.parameter.shouldLoadFullCart ||
        (props.needFullCart && promotionsNotLoaded)
    ) {
        // props.dispatch(loadPromotions({ cartId: props.parameter.cartId }));
    }
});
